import React from "react";

var googleSvg = function googleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.12 16.216c0-.674-.06-1.321-.173-1.943H16v3.675h5.113a4.37 4.37 0 0 1-1.896 2.867v2.383h3.07c1.797-1.653 2.833-4.089 2.833-6.982z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 25.5c2.565 0 4.715-.85 6.287-2.302l-3.07-2.383c-.85.57-1.939.907-3.217.907-2.474 0-4.569-1.672-5.316-3.917H7.51v2.461A9.496 9.496 0 0 0 16 25.5z",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.684 17.805A5.71 5.71 0 0 1 10.386 16c0-.626.108-1.235.298-1.805v-2.461H7.51A9.496 9.496 0 0 0 6.5 16c0 1.533.367 2.984 1.01 4.266z",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.278c1.395 0 2.647.48 3.632 1.421l2.724-2.725C20.711 7.441 18.561 6.5 16 6.5a9.496 9.496 0 0 0-8.49 5.234l3.174 2.461c.747-2.245 2.842-3.917 5.316-3.917z",
    fill: "#ea4335"
  })));
};

googleSvg.defaultProps = {
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
export var google = {
  category: 'social',
  colorable: false,
  name: 'google',
  svg: googleSvg
};